// components
import RMDRImage from '@/components/RMDRImage';
// enums
import EResourceType from '@/cms/enums/EResourceType';
import RMDRSocialShare from './RMDRSocialShare';
import { dateTimeToHumanReadable } from '@/utilities/DateTimeHelper';
import { outerNameDescriptionLanguageVersion } from '@/utilities/LanguageVersionSelectorShortcut';
import TClientContentDetail from '@/cms/types/TClientContentDetail';
import ContentMetricsIcon from './ContentMetrics/ContentMetricsIcon';


type TContentInnerHeader = {

    payload?: TClientContentDetail;
    metaInformationEnabled?: boolean;

}


const ContentInnerHeader = ( props: TContentInnerHeader ) => {
    const languageVersion = outerNameDescriptionLanguageVersion(props.payload?.languageVersions);
    const dateTimeHR = dateTimeToHumanReadable(props.payload?.creationDateTime);

    return (
        <>
            <div className="services-details-image">
                <RMDRImage
                    resourceType={EResourceType.INNER_IMAGE}
                    resources={props.payload?.resources} 
                    alt={languageVersion?.name}
                    title={languageVersion?.name} 
                    className="tw-w-full tw-h-auto"
                />
            </div>
            {
                props.metaInformationEnabled && (
                    <div className="blog-details">
                        <div className="article-content d-md-flex d-block justify-content-between">
                            <ul className="entry-meta">
                                <li>
                                    {
                                        dateTimeHR && (
                                            <>
                                                <i className="fa-solid fa-calendar-days"></i>
                                                <time 
                                                    className="entry-date published" 
                                                    dateTime={props.payload?.creationDateTime}
                                                >
                                                    {dateTimeHR}
                                                </time>
                                            </>
                                        )
                                    }
                                </li>
                                <ContentMetricsIcon />
                            </ul>

                            <div className='social-share'>
                                <RMDRSocialShare 
                                    title={languageVersion?.name} 
                                    contentRouteNavigationURL={languageVersion?.contentRouteNavigationURL}
                                />
                            </div>
                        </div>
                    </div>
                )
            }
        </>
        
    )
}

export default ContentInnerHeader;
